import * as React from 'react';
import { Props as LayoutProps } from './VisitorsDistanceLayout';
import { useEffect, useState } from 'react';
import { reportingEndpoint, userSessionsEndpoint } from '../../../Constants/endpoints';
import { setLoading } from '../../../ReduxApp/app/consts/duck/operations';
import { apiGet } from '../../../utils/axios/getWrapper';
import { DateTime } from 'luxon';
import { getDateRange } from '../../../ReduxApp/app/filters/duck/selectors/ephemeral/getDateRange';
import { useSelector } from 'react-redux';
import { CompleteStore } from '../../../ReduxApp/reducers/reducerTypes';

export type Props = {
	Layout: any;
};

export const VisitorsDistanceContainer = (props: Props) => {
	const refreshTimeout = 12000;
	const [totalVisits, setTotalVisits] = useState(0);
	const [todayVisits, setTodayVisits] = useState(0);
	const [recentVisits, setRecentVisits] = useState(0);
	const [similarVisits, setSimilarVisits] = useState(0);
	const dateRange = useSelector((state: CompleteStore) => getDateRange(state));
	const fetchData = async () => {
		const path = '/visits/count';
		setLoading(true);
		const params = {
			startDate: dateRange.start.toISODate(),
			endDate: dateRange.end.toISODate(),
		};
		console.log('params is', params);
		try {
			const response: any = await apiGet(reportingEndpoint, path, params, true);
			setTotalVisits(response.data.data.totalVisits);
			setTodayVisits(response.data.data.todayVisits);
			setRecentVisits(response.data.data.recentVisits);
			setSimilarVisits(response.data.data.similarVisits);
		} catch (e) {
			console.log(`Error fetching from ${path}`, e);
		}
		setLoading(false);
	};

	useEffect(() => {
		fetchData();
		const interval = setInterval(() => {
			fetchData();
		}, refreshTimeout);
		return () => clearInterval(interval);
	}, [dateRange]);

	const render = () => {
		const Layout = props.Layout;
		const outgoingProps: LayoutProps = {
			totalVisits,
			todayVisits,
			recentVisits: parseFloat(recentVisits.toFixed(2)),
			similarVisits: parseFloat(similarVisits.toFixed(2)),
		};
		const returnValue = <Layout {...outgoingProps} />;
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
